import {
    CREATEIMMUNIZATIONNAME,
    GETIMMUNIZATIONNAME,
    UPDATEIMMUNIZATIONNAME,
    DELETEIMMUNIZATIONNAME,
    CREATEIMMUNIZATIONAGEGROUP,
    GETIMMUNIZATIONAGEGROUP,
    UPDATEIMMUNIZATIONAGEGROUP,
    DELETEIMMUNIZATIONAGEGROUP,
    CREATEOPDVACCINE,
    GETOPDVACCINE,
    UPDATEOPDVACCINE,
    DELETEOPDVACCINE,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEIMMUNIZATIONNAME:
            return {
                ...state,
                immunizationNameSaveStatus: action.payload.success,
            }
        case GETIMMUNIZATIONNAME:
                return {
                        ...state,
                        immunizationNameList: action.payload.data,
                        }
        case UPDATEIMMUNIZATIONNAME:
                return {
                        ...state,
                        immunizationNameUpdateStatus: action.payload.success,
                        }   

        case DELETEIMMUNIZATIONNAME:
                 return {
                     ...state,
                     immunizationNameDeleteStatus: action.payload.success,
                        } 
        case CREATEIMMUNIZATIONAGEGROUP:
                return {
                        ...state,
                        immunizationAgegroupSaveStatus: action.payload.success,
                        }
        case GETIMMUNIZATIONAGEGROUP:
                 return {
                        ...state,
                        immunizationAgegroupList: action.payload.data,
                        }
        case UPDATEIMMUNIZATIONAGEGROUP:
                return {
                        ...state,
                        immunizationAgegroupUpdateStatus: action.payload.success,
                        }   
                
        case DELETEIMMUNIZATIONAGEGROUP:
                    return {
                            ...state,
                            immunizationAgegroupDeleteStatus: action.payload.success,
                            } 
        case CREATEOPDVACCINE:
            return {
                ...state,
                opdvaccineSaveStatus: action.payload.success,
            }
        case GETOPDVACCINE:
                return {
                        ...state,
                        opdvaccineList: action.payload.data,
                        }
        case UPDATEOPDVACCINE:
                return {
                        ...state,
                        opdvaccineUpdateStatus: action.payload.success,
                        }   

        case DELETEOPDVACCINE:
                 return {
                     ...state,
                     opdvaccineDeleteStatus: action.payload.success,
                        } 
        default:
                return state
                      }
                 }